import { ToastName } from '../../types/ToastNames';
import { NotificationTheme } from 'wix-style-react';

export interface ToastParams {
  dataHook: string;
  text: string;
  biName: string;
  theme: NotificationTheme;
  siteText?: string;
  actionButtonText?: string;
}

export const toastNameToParams: { [toastName: string]: ToastParams } = {
  [ToastName.SendInviteSuccess]: {
    dataHook: 'invite-member-success-toast',
    text: 'app.toast.inviteSentSuccessfully',
    biName: 'member-invite-sent-successfully',
    theme: 'success'
  },
  [ToastName.SendInvitesSuccess]: {
    dataHook: 'invite-member-success-toast',
    text: 'app.toast.multipleInvitesSentSuccessfully',
    biName: 'member-invite-sent-successfully',
    theme: 'success'
  },
  [ToastName.LinkCopied]: {
    dataHook: 'link-copied-success-toast',
    text: 'app.toast.linkCopiedSuccessfully',
    biName: 'team-invite-link-copied-successfully',
    theme: 'success'
  },
  [ToastName.RoleUpdated]: {
    dataHook: 'role-updated-success-toast',
    text: 'app.toast.roleUpdatedSuccessfully',
    biName: 'member-role-update-successfully',
    theme: 'success'
  },
  [ToastName.UpdateTeamDetailsSuccess]: {
    dataHook: 'update-team-details-success-toast',
    text: 'app.toast.teamDetailsUpdatedSuccessfully',
    biName: 'team-details-update-successfully',
    theme: 'success'
  },
  [ToastName.RemoveMembersSuccess]: {
    dataHook: 'remove-members-success-toast',
    text: 'app.toast.removeMembersSuccess',
    siteText: 'site.app.toast.removeMembersSuccess',
    biName: 'remove-members-success-toast',
    theme: 'success'
  },
  [ToastName.InviteResendSuccess]: {
    dataHook: 'resend-invite-success-toast',
    text: 'app.toast.resendInviteSuccess',
    biName: 'resend-invite-success-toast',
    theme: 'success'
  },
  [ToastName.SetRoleSuccess]: {
    dataHook: 'set-role-success-toast',
    text: 'app.toast.setRoleSuccessfully',
    biName: 'set-role-success-toast',
    theme: 'success'
  },
  [ToastName.UpdateRoleSuccess]: {
    dataHook: 'update-role-success-toast',
    text: 'app.toast.updateRoleSuccessfully',
    biName: 'update-role-success-toast',
    theme: 'success'
  },
  [ToastName.RemoveRoleSuccess]: {
    dataHook: 'remove-role-success-toast',
    text: 'app.toast.removeRoleSuccessfully',
    biName: 'remove-role-success-toast',
    theme: 'success'
  },
  [ToastName.TransferOwnershipLinkCopied]: {
    dataHook: 'transfer-ownership-link-copied-success-toast',
    text: 'app.toast.transferOwnershipLinkCopiedSuccessfully',
    biName: 'site-transfer-ownership-link-copied-successfully',
    theme: 'success'
  },
  [ToastName.ResendTransferOwnership]: {
    dataHook: 'resend-transfer-ownership-success-toast',
    text: 'app.toast.resendTransferOwnershipSuccessfully',
    biName: 'site-resend-transfer-ownership-successfully',
    theme: 'success'
  },
  [ToastName.CancelTransferOwnership]: {
    dataHook: 'cancel-transfer-ownership-success-toast',
    text: 'app.toast.cancelTransferOwnershipSuccessfully',
    biName: 'site-cancel-transfer-ownership-successfully',
    theme: 'success'
  },
  [ToastName.UpgradePlan]: {
    dataHook: 'upgrade-plan-toast',
    text: 'upgrade_app.toast.upgradePlan',
    actionButtonText: 'upgrade_app.toast.upgradePlanButton',
    biName: 'upgrade-plan-toast',
    theme: 'premium'
  },
};
